<template>
  <div class="th-container">
    <p>{{ message }}</p>
    <img src="@/assets/images/verify.png" alt="Verify">
    <router-link v-if="done" to="/login" class="primary">Log in</router-link>
  </div>
</template>

<script>
import preloader from "@/mixins/preloader";
import {ensureCsrfCookie} from "@/packages/axios";

const verifyRequests = new Map();

function firstToken(...candidates) {
  for (const value of candidates) {
    const token = Array.isArray(value) ? value[0] : value;
    if (typeof token === 'string' && token.trim()) {
      return token.trim();
    }
  }
  return '';
}

function verifiedCacheKey(token) {
  return `giftxyz_verified_${token}`;
}

export default {
  name: "VerifyPage",
  mixins: [preloader],
  data() {
    return {
      done: false,
      message: 'Verifying your email…',
    }
  },
  methods: {
    verificationToken() {
      const pathMatch = window.location.pathname.match(/\/verify\/([^/]+)\/?$/);
      return firstToken(
        this.$route.params.token,
        this.$route.query.token,
        new URLSearchParams(window.location.search).get('token'),
        pathMatch ? decodeURIComponent(pathMatch[1]) : '',
      );
    }
  },
  async mounted() {
    const token = this.verificationToken();
    this.setLoading(false);
    if (!token) {
      this.done = true;
      this.message = 'This verification link is missing its token. Please open the link from your email.';
      return;
    }
    if (sessionStorage.getItem(verifiedCacheKey(token))) {
      this.done = true;
      this.message = 'Your email has been verified. You can now log in.';
      return;
    }
    if (!verifyRequests.has(token)) {
      verifyRequests.set(token, (async () => {
        await ensureCsrfCookie();
        return this.axios.post('verify-email', { token });
      })());
    }
    try {
      const response = await verifyRequests.get(token);
      this.message = response.data.message;
      if (response.data.success === true) {
        sessionStorage.setItem(verifiedCacheKey(token), '1');
      }
    } catch (error) {
      const code = error.response?.data?.code;
      if (code === 'ALREADY_VERIFIED' || sessionStorage.getItem(verifiedCacheKey(token))) {
        this.message = 'Your email has been verified. You can now log in.';
        sessionStorage.setItem(verifiedCacheKey(token), '1');
      } else {
        this.message = error.response?.data?.message || 'Unable to verify your email. Please reopen the email link and try again.';
      }
    } finally {
      this.done = true;
    }
  }
}
</script>

<style lang="scss" scoped>

.th-container {
  min-height: calc(100vh - 152px);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 74px;

  @media screen and (max-width: 480px) {
    margin-top: 77px;
  }
}

img {
  padding-top: 61px;
  @media screen and (max-width: 480px) {
    padding-top: 65px;
  }
}

p {
  font-weight: 500;
  font-size: 36px;
  line-height: 44px;
  color: #252525;
  text-align: center;
  margin: 57px auto 0;
  @media screen and (max-width: 480px) {
    font-weight: 500;
    font-size: 24px;
    line-height: 29px;
    text-align: left;
    margin-top: 75px;
  }
}

.primary {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 352px;
  height: 69px;
  left: 544px;
  top: 679px;
  box-shadow: 0 2.54994px 6.37486px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  font-weight: 700;
  font-size: 20px;
  line-height: 15px;
  margin: 82px auto 30px;

  @media screen and (max-width: 480px) {
    margin-top: 58px;
  }
}
</style>
